module.exports = __webpack_public_path__ + "static/media/02.e2c7c7ec.jpg";